import React, { useLayoutEffect } from "react";
import { Container, Col, Row } from "react-bootstrap";
import facebookpic from "../../Images/facebook.png";
import instagrampic from "../../Images/instagram.png";
import twitterpic from "../../Images/twitter.png";
import phonepic from "../../Images/phone.png";
import FooterHook from "../../hook/FooterHook";
import logo from "../../Images/logo.png";
import android from "../../Images/android.png";
import ios from "../../Images/apple.png";
import { Link, useLocation, useNavigate } from "react-router-dom";

import maroofLogo from "../../Images/gold-logo.png"
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import { IoLogoWhatsapp } from "react-icons/io";
import whatsAppImg from "../../Images/whatsapp.png";




const Footer = () => {
  const [
    facebook,
    instagram,
    twitter,
    phone,
    phone2,
    phone3,
    email,
    address,
    category,
    vatNumber,
    commercialRegister,
    titleAr,
    titleEn,
    googlePlayLink,
    appleStoreLink,
    whatsApp
  ] = FooterHook();


  const navigate=useNavigate();

  const settingsRes = useSelector((state) => state.settingsReducers.settings);

  const location = useLocation()


  const { t } = useTranslation();

  const today = new Date();
  console.log(today.getFullYear()); // e.g. 2025

  return (
    <div className="noon-footer font">
      {location.pathname.startsWith('/admin/') === false ? (
        <div className="noon-footer-main">
          <Container>
            <Row className="gy-4">
              {/* Column 1: About & Links */}
              <Col xs={12} md={4}>
                <h5 className="noon-footer-title">
                  {Cookies.get("i18next") === "ar" ? settingsRes?.data?.titleAr : settingsRes?.data?.titleEn}
                </h5>
                <ul className="noon-footer-links">
                  <li><Link to={`/terms/1`}>{t("Terms and Conditions")}</Link></li>
                  <li><Link to={`/policy/2`}>{t("Refund Policy")}</Link></li>
                  <li><Link to={`/about/3`}>{t("about us")}</Link></li>
                  <li><Link to={`/contactus`}>{t("contact us")}</Link></li>
                </ul>
              </Col>

              {/* Column 2: Quick Links (Categories) */}
              <Col xs={12} md={4}>
                {settingsRes?.data?.showCategory === true && category.data ? (
                  <>
                    <h5 className="noon-footer-title">{t("quick links")}</h5>
                    <ul className="noon-footer-links">
                      {category.data.slice(0, 5).map((el) => (
                        <li key={el._id}>
                          <button
                            onClick={() => {
                              localStorage.setItem('page', 1);
                              navigate(`/products/category/${el._id}`);
                            }}
                            className="btn-link-clean"
                          >
                            {Cookies.get("i18next") === "ar" ? el.nameAr : el.nameEn}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : null}
              </Col>

              {/* Column 3: Contact Info & Apps */}
              <Col xs={12} md={4}>
                <h5 className="noon-footer-title">{t("contact us")}</h5>
                <div className="noon-footer-contact">
                  {address && <p><strong>{t("address")}:</strong> {address}</p>}
                  {phone && <p><strong>{t("phone")}:</strong> {phone}</p>}
                  {vatNumber && <p><strong>{t("Tax Number")}:</strong> {vatNumber}</p>}
                  {commercialRegister && <p><strong>{t("Commercial Register")}:</strong> {commercialRegister}</p>}
                  {email && <p><a href={`mailto:${email}`}>{email}</a></p>}
                </div>

                {/* Social Media & Apps */}
                <div className="noon-footer-social mt-3">
                  {facebook && (
                    <a href={facebook} target="_blank" rel="noreferrer"><img src={facebookpic} alt="Facebook" /></a>
                  )}
                  {twitter && (
                    <a href={twitter} target="_blank" rel="noreferrer"><img src={twitterpic} alt="Twitter" /></a>
                  )}
                  {instagram && (
                    <a href={instagram} target="_blank" rel="noreferrer"><img src={instagrampic} alt="Instagram" /></a>
                  )}
                  {whatsApp && (
                    <a href={`https://api.whatsapp.com/send?phone=${whatsApp}`} target="_blank" rel="noreferrer">
                      <img src={whatsAppImg} alt="WhatsApp" />
                    </a>
                  )}
                </div>

                <div className="noon-footer-apps mt-3">
                  {googlePlayLink && (
                    <a href={googlePlayLink} target="_blank" rel="noreferrer">
                      <img src={android} alt="Google Play" className="app-badge" />
                    </a>
                  )}
                  {appleStoreLink && (
                    <a href={appleStoreLink} target="_blank" rel="noreferrer">
                      <img src={ios} alt="App Store" className="app-badge" />
                    </a>
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      ) : null}

      <div className="noon-footer-bottom">
        <Container>
          <div className="text-center">
            <p className="mb-0">
              {settingsRes?.data?.titleEn} © {new Date().getFullYear()}. {t("all rights reserved")}.
            </p>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default Footer;
